import { createGlobalStyle } from 'styled-components';
import img from './evari.jpg';

const ExamsRStyle = createGlobalStyle`
body {
    background: url(${img}) no-repeat center center fixed;
    background-size: cover;
    background-color: #0a0a0a;
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    min-height: 100vh;
    overflow-x: hidden;
}

/* Main Container */
.results-main {
    min-height: calc(100vh - 140px);
    padding: 2rem 1rem;
}

.results-container {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
}

/* Header */
.results-header {
    text-align: center;
    margin-bottom: 2rem;
}

.results-header h2 {
    font-size: 2rem;
    font-weight: bold;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.8);
    display: inline-block;
    padding: 1rem 2rem;
    border-radius: 10px;
    border: 2px solid #673ab7;
    box-shadow: 0 0 20px rgba(103, 58, 183, 0.4);
    text-shadow: 0 0 10px rgba(166, 13, 224, 0.6);
    margin: 0;
    animation: electric 0.8s infinite;
}

/* Loader */
.loader-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    gap: 2rem;
}

.loader {
    color: #A60DE0;
    font-family: Consolas, Menlo, Monaco, monospace;
    font-weight: bold;
    font-size: 78px;
    opacity: 0.8;
}

.loader:before {
    content: "{";
    display: inline-block;
    animation: pulse 0.4s alternate infinite ease-in-out;
}

.loader:after {
    content: "}";
    display: inline-block;
    animation: pulse 0.4s 0.3s alternate infinite ease-in-out;
}

@keyframes pulse {
    to {
        transform: scale(0.8);
        opacity: 0.5;
    }
}

.loader-text {
    color: #ffffff;
    font-size: 1.5rem;
    font-weight: bold;
    text-shadow: 0 0 10px rgba(166, 13, 224, 0.6);
    text-align: center;
}

/* Result Cards */
.result-card {
    background: linear-gradient(135deg, rgba(30, 10, 40, 0.75) 0%, rgba(60, 20, 80, 0.75) 100%);
    border: 2px solid #673ab7;
    border-radius: 10px;
    padding: 2rem;
    margin: 2rem 0;
    box-shadow: 0 0 0 rgba(103, 58, 183, 0.4), 0 0 20px rgba(166, 13, 224, 0.4);
    animation: shadow-move-purple 4s infinite alternate, slideInUp 0.6s ease-out forwards;
    backdrop-filter: blur(5px);
    position: relative;
    overflow: hidden;
    opacity: 0;
    transform: translateY(30px);
}

.result-card:nth-child(1) { animation-delay: 0s, 0.1s; }
.result-card:nth-child(2) { animation-delay: 0s, 0.2s; }
.result-card:nth-child(3) { animation-delay: 0s, 0.3s; }
.result-card:nth-child(4) { animation-delay: 0s, 0.4s; }
.result-card:nth-child(5) { animation-delay: 0s, 0.5s; }
.result-card:nth-child(6) { animation-delay: 0s, 0.6s; }
.result-card:nth-child(7) { animation-delay: 0s, 0.7s; }
.result-card:nth-child(8) { animation-delay: 0s, 0.8s; }
.result-card:nth-child(9) { animation-delay: 0s, 0.9s; }
.result-card:nth-child(10) { animation-delay: 0s, 1s; }

@keyframes slideInUp {
    0% {
        opacity: 0;
        transform: translateY(30px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.result-card::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: repeating-linear-gradient(
        0deg,
        transparent,
        transparent 2px,
        rgba(103, 58, 183, 0.03) 2px,
        rgba(103, 58, 183, 0.03) 4px
    );
    animation: scan 10s linear infinite;
    pointer-events: none;
}

@keyframes scan {
    0% { transform: translateY(0); }
    100% { transform: translateY(50%); }
}

@keyframes shadow-move-purple {
    0% {
        box-shadow: 0 0 0 rgba(103, 58, 183, 0.4), 0 0 20px rgba(166, 13, 224, 0.4);
    }
    25% {
        box-shadow: 10px 10px 10px rgba(166, 13, 224, 0.4), 0 0 20px rgba(103, 58, 183, 0.4);
    }
    50% {
        box-shadow: 20px 10px 0 rgba(103, 58, 183, 0.4), 0 0 20px rgba(166, 13, 224, 0.4);
    }
    75% {
        box-shadow: -10px -10px 10px rgba(166, 13, 224, 0.4), 0 0 20px rgba(103, 58, 183, 0.4);
    }
    100% {
        box-shadow: -10px -10px 0 rgba(103, 58, 183, 0.4), 0 0 20px rgba(166, 13, 224, 0.4);
    }
}

/* Question Header */
.question-header {
    margin-bottom: 1.5rem;
    position: relative;
    z-index: 1;
}

.question-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #ffff00;
    text-shadow: 0 0 10px rgba(255, 255, 0, 0.8);
    margin: 0 0 0.5rem 0;
}

.question-text {
    font-size: 1.1rem;
    font-weight: bold;
    color: #ffffff;
    text-shadow: 0 0 10px rgba(166, 13, 224, 0.6);
    background: rgba(0, 0, 0, 0.6);
    padding: 1rem;
    border-radius: 5px;
    margin: 0;
}

/* Answer Sections */
.answer-section {
    margin: 1.5rem 0;
    padding: 1rem;
    border-radius: 5px;
    position: relative;
    z-index: 1;
    opacity: 0;
    transform: translateX(-20px);
    animation: slideInLeft 0.5s ease-out forwards;
}

.answer-section:nth-of-type(2) { animation-delay: 0.2s; }
.answer-section:nth-of-type(3) { animation-delay: 0.4s; }

@keyframes slideInLeft {
    0% {
        opacity: 0;
        transform: translateX(-20px);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}

.user-answer {
    background: rgba(139, 69, 19, 0.3);
    border: 2px solid #8B4513;
}

.correct-answer {
    background: rgba(0, 0, 139, 0.3);
    border: 2px solid #000080;
}

.answer-label {
    font-size: 1rem;
    font-weight: bold;
    color: #ffffff;
    text-decoration: underline;
    margin: 0 0 0.75rem 0;
}

.answer-content {
    font-size: 1rem;
    color: #ffffff;
    margin: 0.5rem 0;
    line-height: 1.6;
}

.code-content {
    color: #ffffff;
    background: rgba(0, 0, 0, 0.6);
    padding: 1rem;
    border-radius: 5px;
    border: 1px solid #673ab7;
    margin: 0.5rem 0;
    overflow-x: auto;
    font-family: 'Courier New', monospace;
}

/* Score Badge */
.score-badge-container {
    text-align: center;
    margin-top: 1.5rem;
    position: relative;
    z-index: 1;
    opacity: 0;
    animation: fadeIn 0.5s ease-out 0.6s forwards;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.score-badge {
    display: inline-block;
    padding: 0.75rem 1.5rem;
    border-radius: 5px;
    font-size: 1.25rem;
    font-weight: bold;
    color: #ffffff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    animation: electricbox 0.8s infinite;
}

.score-badge.success {
    background-color: #00ff00;
    border: 2px solid #00ff00;
    color: #000;
}

.score-badge.failure {
    background-color: #ff0000;
    border: 2px solid #ff0000;
}

/* Final Score */
.final-score {
    text-align: center;
    padding: 3rem 2rem;
    margin: 3rem 0;
    border-radius: 10px;
    background: linear-gradient(135deg, rgba(30, 10, 40, 0.9) 0%, rgba(60, 20, 80, 0.9) 100%);
    border: 3px solid;
    backdrop-filter: blur(10px);
}

.final-score h3 {
    font-size: 2rem;
    font-weight: bold;
    margin: 0 0 1rem 0;
}

.final-score-value {
    font-size: 2.5rem;
    font-weight: bold;
    margin: 1rem 0;
}

.retry-message {
    font-size: 1.25rem;
    margin: 1rem 0 0 0;
}

.success-glow {
    border-color: #00ff00;
    color: #00ff00;
    animation: glowing-success 2s infinite;
}

.failure-glow {
    border-color: #ff0000;
    color: #ff0000;
    animation: glowing-failure 2s infinite;
}

@keyframes glowing-success {
    0% {
        text-shadow: 0 0 5px rgba(255, 255, 0, 0.7), 0 0 10px rgba(255, 255, 0, 0.7), 0 0 20px rgba(255, 255, 0, 0.7);
        box-shadow: 0 0 20px rgba(0, 255, 0, 0.5);
    }
    50% {
        text-shadow: 0 0 5px rgba(255, 255, 0, 0.7), 0 0 10px rgba(255, 255, 0, 0.7), 0 0 20px rgba(255, 255, 0, 0.7), 0 0 30px rgba(255, 255, 0, 0.7);
        box-shadow: 0 0 40px rgba(0, 255, 0, 0.8);
    }
    100% {
        text-shadow: 0 0 5px rgba(255, 255, 0, 0.7), 0 0 10px rgba(255, 255, 0, 0.7), 0 0 20px rgba(255, 255, 0, 0.7);
        box-shadow: 0 0 20px rgba(0, 255, 0, 0.5);
    }
}

@keyframes glowing-failure {
    0% {
        text-shadow: 0 0 5px white, 0 0 10px white, 0 0 20px white;
        box-shadow: 0 0 20px rgba(255, 0, 0, 0.5);
    }
    50% {
        text-shadow: 0 0 5px white, 0 0 10px white, 0 0 20px white, 0 0 30px white;
        box-shadow: 0 0 40px rgba(255, 0, 0, 0.8);
    }
    100% {
        text-shadow: 0 0 5px red, 0 0 10px rgba(0, 0, 0, 0.7), 0 0 20px red;
        box-shadow: 0 0 20px rgba(255, 0, 0, 0.5);
    }
}

/* Nav Menu */
header {
    background-color: #333;
    padding: 20px;
    padding-bottom: 30px;
    margin: 0 auto;
}

nav ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

nav ul li {
    display: inline-block;
    margin-right: 20px;
}

nav ul li:last-child {
    margin-right: 0;
}

nav ul li button {
    background-color: transparent;
    border: none;
    cursor: pointer;
}

nav ul li a, nav ul li button {
    color: #fff;
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
}

nav ul li a:hover, nav ul li button:hover {
    color: #673ab7;
    text-shadow: 1px 1px 2px #673ab7, 0 0 1em #A60DE0, 0 0 0.2em yellow;
    animation: electric 0.8s infinite;
}

/* Footer - Handled by EnhancedFooter component */
/* footer {
    margin-top: auto;
    height: 60px;
    background-color: #333;
    color: #fff;
    text-align: center;
    font-size: 18px;
    padding-top: 20px;
} */

/* Animations */
@keyframes electricbox {
    0% {
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
    50% {
        box-shadow: 2px 2px 8px yellow, 0 0 20px red;
    }
    100% {
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
}

@keyframes electric {
    0% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
    50% {
        text-shadow: 2px 2px 8px yellow, 0 0 20px red;
    }
    100% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .results-main {
        padding: 1rem 0.75rem;
    }

    .result-card {
        padding: 1.5rem;
    }

    .results-header h2 {
        font-size: 1.5rem;
        padding: 0.75rem 1.5rem;
    }

    .question-title {
        font-size: 1.25rem;
    }

    .final-score h3 {
        font-size: 1.5rem;
    }

    .final-score-value {
        font-size: 2rem;
    }
}
`;

export default ExamsRStyle;
